import React, { useState } from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import RBSheet from "react-native-raw-bottom-sheet";

import CrossIcon from "@assets/svg/CrossIcon";
import EditIcon from "@assets/svg/EditIcon";
import DeleteIcon from "@assets/svg/DeleteIcon";
import { normalize } from "@constants/metrics";
import t from "@constants/localization";
import { colors } from "@constants/theme";
import Button from "@components/Button";
import { vh } from "@utils/scale";
import { getHardDayMonth } from "@utils/getFormattedDate";
import Text from "@components/CustomText";

const PATH = "screens/Vacation/components/BottomSheet";

const BottomSheet = React.forwardRef(
  ({ onDelete, onEdit, leaveData, setLeaveData }, ref) => {
    const [deleteCheck, setDeleteCheck] = useState(false);

    return (
      <RBSheet
        ref={ref}
        closeOnDragDown={true}
        animationType="slide"
        closeOnPressMask={true}
        customStyles={{
          wrapper: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
          },
          draggableIcon: {
            backgroundColor: "transparent",
          },
          container: {
            borderTopRightRadius: 24,
            borderTopLeftRadius: 24,
            height: !deleteCheck ? vh(230) : vh(330),
          },
        }}
      >
        <View style={styles.sheetContainer}>
          <View style={styles.sheetHeader}>
            <Text
              variant="entityHeading"
              newfont={true}
              style={styles.sheetHeaderText}
            >
              {t(`${PATH}/sVacation`, {
                date: getHardDayMonth(leaveData?.vacation_date),
              })}
            </Text>
            <TouchableOpacity
              onPress={() => {
                ref.current.close();
                setTimeout(() => {
                  setDeleteCheck(false);
                }, 100);
              }}
            >
              <CrossIcon />
            </TouchableOpacity>
          </View>
          <View style={styles.separator} />
          <View style={[styles.sheetBody, { marginTop: 15 }]}>
            <TouchableOpacity
              onPress={() => {
                onEdit(leaveData);
                ref.current.close();
              }}
              style={styles.sheetRow}
            >
              <EditIcon height={24} width={24} />
              <Text
                variant="body_text_4"
                newfont={true}
                style={styles.sheetRowText}
              >
                {t(`${PATH}/edit`)}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                deleteCheck ? setDeleteCheck(false) : setDeleteCheck(true);
              }}
              style={[styles.sheetRow, { marginTop: 28 }]}
            >
              <DeleteIcon height={24} width={24} />
              <Text
                variant="body_text_4"
                newfont={true}
                style={styles.sheetRowText}
              >
                {t(`${PATH}/delete`)}
              </Text>
            </TouchableOpacity>
          </View>
          {deleteCheck ? (
            <React.Fragment>
              <View
                style={{
                  justifyContent: "center",
                  marginStart: 42,
                  marginTop: 8,
                }}
              >
                <Text
                  variant="body_text_3"
                  newfont={true}
                  style={{
                    color: colors.lightBlack,
                  }}
                >
                  {t(`${PATH}/wantToDelete`)}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 24,
                  marginStart: 42,
                }}
              >
                <Button
                  btnText={t(`${PATH}/no`)}
                  textColor={colors.mediumBlack}
                  buttonColor={colors.white}
                  onPress={() => {
                    ref.current.close();
                    setDeleteCheck(false);
                  }}
                  buttonFontType="content2"
                  buttonWidth="95%"
                  height={40}
                  borderRadius={8}
                  borderColor={"rgba(0, 0, 0, 0.2)"}
                />
                <Button
                  btnText={t(`${PATH}/yes`)}
                  buttonColor={"#FF2E00"}
                  onPress={() => {
                    onDelete(leaveData);
                    ref.current.close();
                    setDeleteCheck(false);
                  }}
                  buttonFontType="content1"
                  buttonWidth="95%"
                  height={40}
                  borderRadius={8}
                />
              </View>
            </React.Fragment>
          ) : null}
        </View>
      </RBSheet>
    );
  },
);

const styles = StyleSheet.create({
  sheetContainer: {
    paddingHorizontal: 24,
  },
  sheetHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  sheetHeaderText: {
    marginBottom: 0,
    paddingHorizontal: 0,
  },
  separator: {
    height: 1,
    backgroundColor: colors.lighterBlack,
    width: "100%",
    alignSelf: "center",
    marginTop: normalize(24),
  },
  sheetRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  sheetRowText: {
    marginLeft: normalize(15),
    color: colors.mediumBlack,
  },
});

export default BottomSheet;
